import { getDefaultMeta, sendGameTransactionEvent, sendSysUI } from './common';
import { SubscriptionTier } from '@wwe-portal/entities/subscription.type';

import { OfferData } from '@wwe-portal/entities/offer.type';
import { v4 } from 'uuid';
import { PaymentContext } from '@wwe-portal/web/providers/stores/payment-store';
import { useGetCurrentUserId } from '@wwe-portal/web/providers/stores/auth-store';

const mapItemType: Record<SubscriptionTier, string> = {
  [SubscriptionTier.BRONZE]: 'subscription_premium_item',
  [SubscriptionTier.SILVER]: 'subscription_prestige_item',
  [SubscriptionTier.GOLD]: 'subscription_super_vip_item',
};

export const sendExclusiveItemsRevampLoadedEventSysUI = (
  data: {
    GOLD: OfferData[];
    SILVER: OfferData[];
    BRONZE: OfferData[];
  },
  userId: string
) => {
  sendSysUI({
    sys_user_id: userId,
    flow_name: 'web_portal_subscription',
    interaction_type: 'load',
    interaction_object: null,
    screen_content: JSON.stringify({
      exclusive_items: Object.values(SubscriptionTier).map((tier) => ({
        item_type: mapItemType[tier],
        item_list: data[tier].map((item) => item.OffersID),
      })),
    }),
    interaction_object_category: null,
    flow_order: null,
    screen_category: 'store',
    screen_subcategory: 'subscription_exclusive_store',
    screen_type: 'screen',
  });
};

export const useClubcoinTransactionAnalytics = () => {
  const transaction_id = v4();
  const userId = useGetCurrentUserId();

  const sendPurchaseSuccessEvent = (
    offer: OfferData,
    { currentUser, balance }: Pick<PaymentContext, 'currentUser' | 'balance'>
  ) => {
    const item_balance = balance.clubCoin;
    const { sys_user_id, sys_platform, sys_os_s, reference_id } =
      getDefaultMeta();

    const initialParameters = {
      sys_user_id: userId ?? sys_user_id,
      sys_platform,
      sys_os_s,
      currentUser,
      event_source: 'web_portal',
      trans_type: 'web_currency_spend',
      transaction_id,
      context: offer?.OffersID ?? null,
      reference_id,
    };

    sendGameTransactionEvent({
      ...initialParameters,
      trans_desc: 'buy_item',
      transaction_type: 'spend',
      quantity:
        offer.AlternativeCostAmount != null
          ? -offer.AlternativeCostAmount
          : null,
      item_id: 'web_currency_club_coin',
      item_name: 'club_coin',
      item_balance,

      reference_subtype_3: reference_id,
    });

    offer.analyticsItems?.forEach((item) => {
      sendGameTransactionEvent({
        ...initialParameters,
        trans_desc: 'earn_item',
        transaction_type: 'earn',
        quantity: Number(item.quantity),
        item_id: item?.shardID ?? item.itemID ?? null,
        item_name: item.itemName ?? null,
        item_balance: null,
        reference_subtype_3: reference_id,
      });
    });
  };
  return {
    sendPurchaseSuccessEvent,
  };
};
